import { Controller } from "@hotwired/stimulus"

// Cobrança na remoção: no estágio da venda só faz sentido combinar forma de
// porta (dinheiro/maquininha) — se o cliente pagaria PIX/cartão agora, pagaria
// pelo link no fluxo normal. Esconde essas opções (e o misto) quando
// "Na remoção" está marcado; o PIX continua disponível NA PORTA, na tela do
// motorista. A validação do modelo é a garantia server-side.
export default class extends Controller {
  static targets = ["hideOnRemoval"]

  connect() {
    this.toggle()
  }

  toggle() {
    const onRemoval = this.element.querySelector(
      'input[name$="[charge_moment]"][value="on_removal"]'
    )?.checked

    this.hideOnRemovalTargets.forEach((el) => {
      el.classList.toggle("hidden", !!onRemoval)
      if (onRemoval) {
        el.querySelectorAll("input:checked").forEach((input) => {
          input.checked = false
          input.dispatchEvent(new Event("change", { bubbles: true }))
        })
      }
    })
  }
}
